export default {
  setStripeCheckoutSessionLoadingState(state, loading) {
    state.checkoutSessionLoading = loading;
  },
  setStripeCheckoutSessionIdState(state, id) {
    state.checkoutSessionId = id;
  },
};
